export function getOutputFormatLabel(format: string) {
  const formatLabels: Record<string, string> = {
    table: 'Table',
    list: 'List',
    freeform: 'Free Form',
    memo: 'Memo',
    briefing: 'Briefing',
    chronology: 'Chronology',
  };
  return formatLabels[String(format || '').toLowerCase()] || 'List';
}

export function truncateName(name: string, maxChars: number = 15) {
  const s = String(name || '');
  return s.length > maxChars ? `${s.slice(0, maxChars)}...` : s;
}
